// removed by extract-text-webpack-plugin
module.exports = {"component":"aIH9LKGpsnFJyPI9W2kj1","hidden":"_3u0_qOUnFZQ_KvCl0n65Ar","filterTitle":"_2DlX2TPMBLzdBbfTj6Z4Zs","dateFilter":"_2eysuDV73N7Euc40zQV4T3","filterSubmitBtn":"lIO5p4gToQAUm3l8TV_W5","active":"_3GTExkirLuwfvziEPOvYdA","control":"_3inR2tCGPhbRKfgfrDWdz-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/Health/HealthRecordFilter/HealthRecordFilter.css
// module id = 1271
// module chunks = 0